import * as React from 'react'
import styled from '../theme/styled'
import KeravaRadarInfo from './KeravaRadarInfo'

const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: ${({ theme }) => `${theme.color.white}`};
  min-width: 210px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
  transition: all 0.2s;
`

const Wrapper = styled.div`
    display: none;
    position: relative;
    display: inline-block;
    transition: all 0.2s;
    cursor: pointer;

    &:hover  ${DropdownContent} {
      display: block;
    }
`

const NavbarListLi = styled.div`
  padding: 10px 15px;
  text-transform: uppercase;
  font-weight: 400;
  color: ${({ theme }) => `${theme.color.textDark}`};
  font-size: ${({ theme }) => theme.button.sizes.small.fontSize};
`

const Link = styled.a`
  color: ${({ theme }) => `${theme.color.textDark}`};
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) => `${theme.color.textLight}`};
  }
`

class DropdownNav extends React.PureComponent {
  render() {
    return (
      <Wrapper>
        <span>Navigation</span>
        <DropdownContent>
          <NavbarListLi>
            <KeravaRadarInfo />
          </NavbarListLi>
          <NavbarListLi>
            <Link href="https://www.vaisala.com/en/products/instruments-sensors-and-other-measurement-devices/weather-radar-products/iris-focus">
              IRIS
              </Link>
          </NavbarListLi>
          <NavbarListLi>
            <Link href="https://www.vaisala.com/en/lp/contact-form">
              Contact and support
              </Link>
          </NavbarListLi>
        </DropdownContent>
      </Wrapper>
    )
  }
}

export default DropdownNav



// WEBPACK FOOTER //
// ./src/components/DropdownNav.tsx